export default {
  method_unavailable: 'Questo metodo di pagamento non è disponibile al momento. Scegline un altro.',
  payment_option_unavailable:
    'Questa opzione di pagamento non è disponibile al momento. Scegli un altro metodo di pagamento.',
  online_payment_unavailable: 'Il pagamento online non è disponibile al momento. Riprova tra qualche istante.',
  retry_payment_methods: 'Riprova',
  payment_not_ready: 'Il pagamento è ancora in fase di preparazione. Riprova tra un momento.',
  wallet_total_changed:
    'Il totale per questo metodo di pagamento è cambiato. Controllalo e tocca di nuovo il pulsante.',
  wallet_tap_above: 'Tocca il pulsante {{method}} qui sopra per pagare, oppure scegli un altro metodo di pagamento.',
  wallet_pay_above: 'Usa il pulsante {{method}} qui sopra',
  element_incomplete: 'Completa i dati di pagamento per continuare.',
  element_incomplete_card: 'Controlla i dati della carta e riprova.',
  element_incomplete_bank: 'Scegli la tua banca per continuare.',
  element_incomplete_sepa_debit: 'Controlla IBAN e intestatario del conto per continuare.',
};
